<script lang="ts" setup>
import { useTranslations } from '~/composables/translations';
import { computed } from 'vue';
import InitialDotView from '~/components/common/InitialDotView.vue';

// PROPS
interface Props {
  lab: any;
  explore: boolean;
  selectedLabs: any;
  customLabel: string;
  labLink?: string;
}

const props = withDefaults(defineProps<Props>(), {
  lab: undefined,
  explore: true,
  selectedLabs: undefined,
  customLabel: '',
  labLink: undefined,
});

// EMITS
const emit = defineEmits(['toggleSelected']);

// NLS
const { $i18n } = useTranslations('components/common/map_popup');

// COMPUTED
const buttonLabel = computed(() => {
  if (props.explore) {
    return $i18n('requestPrint');
  }

  if (props.selectedLabs.includes(props.lab.id)) {
    return $i18n('deselect');
  }

  return $i18n('select');
});
</script>

<template>
  <div class="lab-card-view">
    <div class="lab-title col-md-12">
      {{ lab.shopName }}
    </div>
    <div class="col-md-12 lab-card-container">
      <div class="lab-template-container">
        <div class="root-template">
          <div class="col-md-4 col-sm-4 col-xs-4 logo-container">
            <div class="initial-dot-view">
              <InitialDotView :image="lab.logoUrl" :title="lab.shopName" />
            </div>
          </div>
          <div class="col-md-8 col-sm-8 col-xs-8 txt-container">
            <a
              class="col-sm-12 more-information-lab-select mp3dp-link text-center"
              :href="labLink"
              target="_blank"
            >
              {{ $i18n('moreInformation') }}
            </a>
            <input
              type="button"
              class="text-center btn btn-primary collection-search-lab-button-select"
              :value="buttonLabel"
              @click="emit('toggleSelected', lab.id)"
            />
          </div>
          <div v-if="customLabel">
            {{ customLabel }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
